import React, { useState, useEffect, useCallback, useRef } from 'react';
import intl from 'react-intl-universal';
import { Image, Button, Toast, Swiper } from 'antd-mobile'
import { GiftOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import { stripHtmlTags, renderImageUrl } from '../../utils';
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp';
import CouponType from './CouponType';
import styles from './index.module.css';

import { getCouponRuleModel, receiveCouponModel, getAllCouponListModel } from '../../model/store';
import { getLanguageStore } from '../../utils/storage/language';
import { getMemberInfo } from '../../utils/storage/store';
const CouponList = ({
    ids,
    from = '',
    list = [],
    activityCoupons = [],
    callback,
    style = {},
    cls = '',
    showUseRule = false,
    getCouponCount,
    storeId = '',
    placeFlag = '',
    showGetButton = true
}) => {
    const [couponList, setCouponList] = useState([]);
    const [loading, setLoading] = useState(false);

    const { memberId = '' } = getMemberInfo() || {};
    const initialized = useRef(false);

    const initCouponList = useCallback(() => {
        if (initialized.current) return;
        initialized.current = true;

        if (from !== 'coupons') {
            getCouponRuleModel({
                couponRuleIds: ids,
                curLanguage: getLanguageStore,
                memberId
            }, true).then(res => {
                setCouponList(res);
                console.log(res, '//couponRuleModel////');
            }).catch(err => {
                console.log(err, '///////err///////')
            });
        } else {
            setCouponList(list);
        }
    }, [from, ids, memberId, list]);

    useEffect(() => {
        initCouponList();
    }, [initCouponList]);

    const getCouponValidDate = (item) => {
        var countType = {
            3: intl.get('day').d('天'),
            4: intl.get('hour').d('小时'),
            5: intl.get('minute').d('分钟')
        };
        var expiredStr = countType[item.validityBeginCountType] || intl.get('day').d('天');
        var validTxt = '';
        if (item.validityBeginType === 1) {
            validTxt = dayjs(item.validityStartTime).format('YYYY-MM-DD') + ' ~ ' + dayjs(item.validityEndTime).format('YYYY-MM-DD');
        } else if (item.validityBeginType === 2) {
            validTxt = intl.get('unlimited').d('无限');
        } else if (item.validityBeginType === 3) {
            validTxt = getValidText(item, intl.get('effective_now').d('即时生效'), expiredStr)
        } else if (item.validityBeginType === 4) {
            validTxt = getValidText(item, intl.get('valid_time').d('有效时间'), expiredStr)

        }

        return validTxt
    }
    const getValidText = (item, str, expiredStr) => {
        const lanKey = getLanguageStore()
        let validTimeStr = intl.get('valid_time').d('有效时间') || '有效时间'
        if(lanKey ==='th_TH'){
            validTimeStr = validTimeStr + ': ' + 'ภายใน'
        }

        
        var text = '';
        if (item.validityBegin === 0) {
            text = (intl.get('effective_now').d('即时生效') || '即时生效') + ', ' + validTimeStr + ' ' + item.validityBeginCount + ' ' + expiredStr;
        } else {
            //todo 
            // text = str.format(item.validityBegin, item.validityBeginCount, expiredStr);
        }
        return text
    }

    /**
     * 添加领取优惠券活动日志
     * @param {string} ruleIds 优惠券规则ID
     * @param {boolean} getAll 是否领取所有优惠券
     * @returns {string} 活动ID
     */
    const addGetCouponActivityLog = (ruleIds, getAll) => {
        if (activityCoupons.length === 0) return '';

        const getActivityIds = () => {
            if (getAll) {
                return activityCoupons.map(item => item.activityId);
            }
            if (activityCoupons.length === 1) {
                return [activityCoupons[0].activityId];
            }
            return activityCoupons
                .filter(item => item.param2 === String(ruleIds))
                .map(item => item.activityId);
        };

        const activityId = getActivityIds().join(',');

        addBehaviorsRecord({
            behaviorType: 160100,
            behavior: 160104,
            storeId: storeId,
            value1: placeFlag,
            value2: activityId,
            value3: ruleIds
        });
    }

    const doGetCoupon = ({ couponRuleId, repeatCount, getAll = false }) => {
        setLoading(true)

        let model = receiveCouponModel
        let param = {
            memberId,
            couponRuleId,
            couponRuleIds: ''
        }
        if (repeatCount > 1 || getAll) {
            model = getAllCouponListModel
            param = {
                memberId,
                couponRuleIds: getAll ? ids : Array.from({ length: repeatCount }).map(item => couponRuleId).join(',')
            }
        }

        if (!param.memberId) {
            const info = getMemberInfo()
            param.memberId = info.memberId
        }

        model(param).then(res => {
            Toast.show({
                content: intl.get('get_success').d('领取成功'),
                icon: 'success',
                duration: 2000
            })
            // getCouponList()

            getCouponCount && getCouponCount()

            setCouponList(prev => {
                return prev.map(item => {
                    if (getAll) {
                        return { ...item, couponState: 1 }
                    } else {
                        if (item.couponRuleId === couponRuleId) {
                            return { ...item, couponState: 1 }
                        }
                    }

                    return item
                })
            })

            addGetCouponActivityLog(param.couponRuleId || param.couponRuleIds, getAll);

            setLoading(false)
        }).catch(err => {
            console.log(err, '///////err///////')
            Toast.show({
                content: intl.get('get_fail').d('领取失败'),
                icon: 'fail',
                duration: 2000
            })
            setLoading(false)
        })
    }

    const getRepeatIdCount = (id) => {
        if (!ids) return 0;
        const arr = ids.split(',');
        return arr.filter(item => item === String(id)).length;

    }

    const renderCouponItem = (coupon, index) => {
        return (
            <div className={`jm-flex`} style={{ gap: '10px', alignItems: 'start' }}>
                <div className={styles.leftSection}>
                    <div className={styles.type}>
                        <Image src={renderImageUrl({ src: coupon.imgUrl })}
                            width={99}
                            height={64}
                            style={{ borderRadius: 6 }}
                            lazy
                            alt="coupon" />
                    </div>
                </div>
                <div className={styles.rightSection}>
                    <div className={styles.couponInfo}>
                        <h3 className={styles.title}>{coupon.couponName}</h3>
                        <p className={styles.expireDate}>{intl.get('valid_period').d('有效期')}: {getCouponValidDate(coupon)}</p>

                        {
                            showUseRule && coupon.useRule && (
                                <>
                                    <div className={styles.rules}>{intl.get('use_rule').d('使用规则')}</div>
                                    <div className={styles.useRule}> <div dangerouslySetInnerHTML={{ __html: stripHtmlTags(coupon.useRule) }}></div></div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div
            className={`${styles.couponContainer} ${cls}`}
            style={{ ...style }}
        >

            {
                couponList?.filter(item => item.couponState !== 1).length > 1 && (<div className='p10 text-right'>
                    <Button
                        size='small'
                        color='primary'
                        fill='outline'
                        shape='rounded'
                        loading={loading}
                        style={from !== 'popup' ? { fontWeight: 'bold' } : { fontWeight: 'bold', color: '#fff', borderColor: '#fff' }}
                        onClick={() => {
                            doGetCoupon({ getAll: true })
                        }}
                    >
                        {intl.get('h_collect_all').d('Collect All')} <GiftOutline />
                    </Button>
                </div>)
            }
            {
                couponList.map((coupon, index) => {
                    const repeatCount = getRepeatIdCount(coupon.couponRuleId);

                    return <div key={index} className={`${styles.couponItem} popup-coupon-item`}>
                        {
                            repeatCount > 1 ?
                                <Swiper
                                    autoplay
                                    loop
                                    indicator={(total, current) => (
                                        <div className={styles.indicator}>
                                            {current + 1} / {total}
                                        </div>
                                    )}
                                >
                                    {
                                        Array.from({ length: repeatCount }).map((_, i) => (
                                            <Swiper.Item key={i}>
                                                {renderCouponItem(coupon, index)}
                                            </Swiper.Item>
                                        ))
                                    }
                                </Swiper>
                                :
                                renderCouponItem(coupon, index)

                        }


                        {/* {renderCouponItem(coupon, index)} */}
                        <div className={`${styles.storeInfo}`}>
                            {/* <CouponType couponType={coupon.couponType} /> */}
                            <div>&nbsp;</div>

                            <Button
                                size='small'
                                loading={loading}
                                color='primary'
                                shape='rounded'
                                className={`${styles.useButton} ${coupon.couponState === 1 ? styles.disabled : ''}`}
                                style={!showGetButton ? { visibility: 'hidden' } : null}
                                onClick={() => {
                                    if (coupon.couponState === 1) {
                                        return
                                    }
                                    doGetCoupon({ couponRuleId: coupon.couponRuleId, repeatCount })
                                }}>
                                {
                                    coupon.couponState === 1 ?
                                        intl.get('has_received').d('已领取') :
                                        (repeatCount > 1 ? intl.get('h_collect_all').d('Collect All') : intl.get('h_collect').d('领取'))
                                }
                            </Button>
                        </div>
                    </div>
                })
            }
        </div>
    );
};

export default CouponList;